import { Controller } from "@hotwired/stimulus";
import renderMessageMarkdown from "./render_message_markdown";

export default class extends Controller {
  static values = { content: String };

  contentValueChanged() {
    if (!this.contentValue) return;
    renderMessageMarkdown(this.element, this.contentValue);
  }
}
